/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Distirbution_HelpInputs */



/**
* | output |
* | --- |
* | "Temperature rise speed of the network thermostatic valves. Valves are grouped when values are close" |
*
* @param {Manual_Balancing_Distirbution_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_distirbution_help = /** @type {((inputs?: Manual_Balancing_Distirbution_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Distirbution_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Temperature rise speed of the network thermostatic valves.\nValves are grouped when values are close")
	return /** @type {LocalizedString} */ ("Vitesse de montée en température des\ntêtes th. du réseau. Les têtes th. sont\ngroupées si les valeurs sont proches")
});